import React, { PureComponent } from 'react'
import { URL } from "app/config/api-config"
import trans from "trans"
import { ShapeSet } from "app/types/model-types"
import { getIconByType } from "shape-list/components/shape-list-item";
import { Icon, Theme, Button, } from "@bdfx/mergado-ui-kit"

export interface Props {
    data: ShapeSet
    onClick: Function
}

class SetSelectionItem extends PureComponent<Props> {
    constructor(props) {
        super(props)
    }

    onClick = () => this.props.onClick()

    getIconBySetName(setName: string, iconSize: number = 32, color: string = '#009ca8') {
        switch (setName) {
            case 'borders':
                return getIconByType('dashedFrame', iconSize, color)
            case 'summer':
                return <Icon type={'sun-o'} size={iconSize} color={color} />
            case 'autumn':
                return <Icon type={'leaf'} size={iconSize} color={color} />
            case 'winter':
                return <Icon type={'tree'} size={iconSize} color={color} />
            case 'emoji':
                return <Icon type={'smile-o'} size={iconSize} color={color} />
            case 'free-delivery':
                return <Icon type={'truck'} size={iconSize} color={color} />
            case 'black-friday':
                return <img src={`${URL.publicPath}img/sets/black-friday/black-friday.svg`} style={{
                    filter: "brightness(0) saturate(100%) invert(40%) sepia(75%) saturate(2412%) hue-rotate(156deg) brightness(92%) contrast(105%)",
                }} width={iconSize} />
            case 'valentine':
                return <img src={`${URL.publicPath}img/sets/valentine/valentine.svg`} width={iconSize} />
            case 'easter':
                return <img src={`${URL.publicPath}img/sets/easter/easter.svg`} width={iconSize} />
            case 'background':
                return <img src={`${URL.publicPath}img/sets/background/background.png`} width={iconSize} />
            case 'generic':
                return <Icon type={'component-1-radix'} size={iconSize} color={color} />
            case 'rating':
                return <img src={`${URL.publicPath}img/sets/rating/rating.svg`} width={iconSize} />
            case 'tags':
                return <Icon type={'tag'} size={iconSize} color={color} />
            default:
                return <span />
        }
    }

    render() {
        const { data } = this.props
        return (
            <Button secondary={true} onClick={(e) => this.onClick()}>
                <div className={'thumb-wrapper'}>
                    {this.getIconBySetName(data.name)}
                </div>
                <div className={'muk-icon__text'}>{trans(data.name)}</div>
            </Button>
        )
    }
}

export default SetSelectionItem
